import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../store/app.states';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {GetPatients} from '../../../store/actions/doctor.actions';
import {Patient} from '../../../model/user/Patient';
import {FormGroup} from '@angular/forms';
import * as _moment from 'moment';
import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';
import {BaseChartDirective} from 'ng2-charts';
import {Chart} from 'chart.js';
import {DoctorService} from '../../../services/doctor.service';
import {InactivePatient} from '../../../model/user/InactivePatient';
import {ConfirmDialogComponent} from '../../user-actions/confirm-dialog/confirm-dialog.component';
import {MatTableDataSource} from '@angular/material/table';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {MatSort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatCheckbox, MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-general-status',
  templateUrl: './general-status.component.html',
  styleUrls: ['./general-status.component.css']
})
export class GeneralStatusComponent implements OnInit {
  getAuthState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  // servono per la comparsa/scomparsa di componenti nella pagina web
  isDataAvailable = true;
  title = 'Status applicazione'; // titolo generale
  patientSSN: string;
  getDoctorState: Observable<any>;
  @ViewChild(MatSort) sort: MatSort;
  //
  constructor(private router: Router,
              private store: Store<AppState>,
              private doctorService: DoctorService,
              public dialog: MatDialog) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  // la funzione è fondamentale per il render della pagina web perchè si esegue all'inizio
  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
    });
  }
}
